module.exports = {
          srcSet: __webpack_public_path__ + "7bd964a8e683ed85fe14b34be35ccd7d-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "7bd964a8e683ed85fe14b34be35ccd7d-1920.png",width: 1920,height: 563}],
          src: __webpack_public_path__ + "7bd964a8e683ed85fe14b34be35ccd7d-1920.png",
          toString:function(){return __webpack_public_path__ + "7bd964a8e683ed85fe14b34be35ccd7d-1920.png"},
          
          width: 1920,
          height: 563
        }